const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const LOWER = "abcdefghijkmnopqrstuvwxyz";
const DIGITS = "23456789";
const SPECIAL = "!@#$%&*_-+=?";
const GROUPS = [UPPER, LOWER, DIGITS, SPECIAL];
const ALL = GROUPS.join("");

const randomIndex = (size) => {
  const sample = new Uint32Array(1);
  const bound = Math.floor(0x100000000 / size) * size;
  do { window.crypto.getRandomValues(sample); } while (sample[0] >= bound);
  return sample[0] % size;
};

export const generateSecurePassword = () => {
  const characters = GROUPS.map((group) => group[randomIndex(group.length)]);
  while (characters.length < 16) characters.push(ALL[randomIndex(ALL.length)]);
  for (let index = characters.length - 1; index > 0; index--) {
    const swap = randomIndex(index + 1);
    [characters[index], characters[swap]] = [characters[swap], characters[index]];
  }
  return characters.join("");
};
